import { apiBaseUrl, assetsShared } from './constants';

const storageEdgeUrl = process.env.NEXT_PUBLIC_STORAGE_EDGE_URL || '';

const assetParams = {
    companyLogo: { key: 'client-company-logo-v01', hash: 'ee58436f4a313bd2aad38d73647bfb1e2d7a1b66', format: '.jpeg' },
    partnerLogo: { key: 'client-partner-logo-v01', hash: '5efbdb475518e4acfe7d913951c29fd906920ce5', format: '.jpeg' },
    card: {
        key: 'client-card-v01',
        hash: '77e05151ceaf207558d2a92f3a9623daf2acaed5',
        format: '.jpeg',
    },
    view: {
        key: 'client-view-v01',
        hash: 'a8bb68ee0e1d32a0c80e909bed312dcd4bf752fc',
        format: '.jpeg',
    },
    promoCardMobile: {
        key: 'client-promo-card-mobile-v01',
        hash: '95a40712dcacd4ee80e416d2bef5f96485aeefea',
        format: '.webp',
    },
    promoCardDesktop: {
        key: 'client-promo-card-desktop-v02',
        hash: '99082cac5b523834cb34635e85efc62563bfa21e',
        format: '.webp',
    },
};

export type AssetKey = keyof typeof assetParams;

export function getAssetUrls(
    parts: Array<string | null | undefined>,
    key: AssetKey,
): { prepared: string; onDemand: string } | { default: string } {
    const assetId = parts.find(Boolean);
    if (!assetId) return { default: assetsShared.defaultCoverImage };
    return {
        prepared: `${storageEdgeUrl}/${assetId}__${assetParams[key].hash}${assetParams[key].format}`,
        onDemand: `${apiBaseUrl}/assets/${assetId}?key=${assetParams[key].key}`,
    };
}

export async function getPreparedAssetUrl(parts: Array<string | null | undefined>, key: AssetKey): Promise<string> {
    const assetUrls = getAssetUrls(parts, key);
    if ('default' in assetUrls) return assetUrls.default;
    const hasPrepared = await fetch(assetUrls.prepared, { next: { revalidate: 7200 } }).then((res) => res.ok);
    if (hasPrepared) return assetUrls.prepared;
    await fetch(assetUrls.onDemand);
    const didPrepare = await fetch(assetUrls.prepared, { next: { revalidate: 7200 } }).then((res) => res.ok);
    return didPrepare ? assetUrls.prepared : assetUrls.onDemand;
}
